import { createContext } from 'react';
import {
	IDataGetCategoryInfoV2,
	IItemForGetShortInfoWithStatus,
	IGetCategoryRestaurantProperties,
	TLanguageIDs,
	TCategoryType,
} from 'types';

export type TTCategoryType = Nullable<TCategoryType>;
export type TTypeOfModalWindow = null | 'assignRestaurants' | 'errorUpdatingCategory';

export interface IViewCategoryState {
	needRefetchData: boolean;
	categoryFullInfo: Nullable<IDataGetCategoryInfoV2>;
	accessibleRestaurants: IItemForGetShortInfoWithStatus[];
	restaurantIdForRestaurantProps: Nullable<string>;
	restaurantProps: Nullable<IGetCategoryRestaurantProperties['data']>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const viewCategoryInitialState: IViewCategoryState = {
	needRefetchData: false,
	categoryFullInfo: null,
	accessibleRestaurants: [],
	restaurantIdForRestaurantProps: null,
	restaurantProps: null,
	selectedTranslationTab: null,
	typeOfModalWindow: null,
};

export interface IViewCategoryContext extends IViewCategoryState {
	refetchData(value: boolean): void;
	setRestaurantIdForRestaurantProps(value: Nullable<string>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const ViewCategoryContext = createContext<IViewCategoryContext>({
	refetchData: () => undefined,
	setRestaurantIdForRestaurantProps: () => undefined,
	setTranslationTab: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...viewCategoryInitialState,
});
